module.exports = __webpack_public_path__ + "static/img/03.d03012c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-companyInfo/03.jpg
// module id = 5N1+
// module chunks = 1